import { drawerCloseButtonBaseStyle, drawerOverlayBaseStyle, sizes } from '../../overlay/drawer';
const baseStyle = (props) => ({
    overlay: drawerOverlayBaseStyle(props),
    closeButton: drawerCloseButtonBaseStyle(props)
});
export const Drawer = {
    sizes,
    baseStyle
};
